import { render, staticRenderFns } from "./ClickJumpClient.vue?vue&type=template&id=36ce7ae2&scoped=true"
import script from "./ClickJumpClient.vue?vue&type=script&lang=js"
export * from "./ClickJumpClient.vue?vue&type=script&lang=js"
import style0 from "./ClickJumpClient.vue?vue&type=style&index=0&id=36ce7ae2&prod&scoped=true&lang=less"
import style1 from "./ClickJumpClient.vue?vue&type=style&index=1&id=36ce7ae2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce7ae2",
  null
  
)

export default component.exports